import { Popover } from '@execonline-inc/execonline-ui';
import { flip, shift } from '@floating-ui/react';
import { fromNullable } from 'maybeasy';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { ExperienceResource } from '../../../../../../CurrentCollectionStep/BuilderV2/Types';
import DisplayPopover from '../../../../../Section/PopoverContent/DisplayPopover';
import CardContent from '../ExperienceCard/CardContent';
import { calculatePlacementOffset, useProgramPopoverPlacement } from './Types';

export interface Props {
  experienceResource: ExperienceResource;
}

function PopoverContent({ experienceResource }: Props) {
  const placement = useProgramPopoverPlacement();
  const middleware = useMemo(
    () => [calculatePlacementOffset(placement), flip(), shift()],
    [placement],
  );
  return (
    <Popover
      className="max-w-[20.625rem] text-black"
      trigger="hover"
      delay={{ open: 100, close: 0 }}
      returnFocus={false}
      placement={placement}
      middleware={middleware}
      renderTrigger={(ref, getReferenceProps) => {
        // Strip role and problematic ARIA attrs that cause violations for hover-only triggers
        const {
          role,
          'aria-haspopup': ariaHasPopup,
          'aria-expanded': ariaExpanded,
          ...restProps
        } = getReferenceProps();
        return (
          <div ref={ref} {...restProps}>
            <CardContent experienceResource={experienceResource} />
          </div>
        );
      }}
      onClose={({ refs }) => {
        fromNullable(refs.domReference.current).do((element) => {
          element.focus({ preventScroll: true });
        });
      }}
    >
      <DisplayPopover experienceResource={experienceResource} />
    </Popover>
  );
}

export default observer(PopoverContent);
